// 能力版块
const BOARDS = [
	'交际应用',
	'发音掌握',
	'句子理解',
	'字母认知',
	'综合写作',
	'综合理解',
	'自然拼读',
	'词汇掌握',
	'语法结构'
];

//单元测试的能力板块
const TRAININGS = ['听力理解', '发音掌握', '阅读能力'];

// 题型
const QUESTION_TYPES = {
	'1101': '看图选图片',
	'1102': '听声选图片',
	'1103': '看单词选图片',
	'1104': '看句子选图片',
	'1105': '看图片听声音选图片',
	'1106': '看图片和单词选图片',
	'1107': '看图片和句子选图片',
	'1108': '听声音看句子选图片',
	'1201': '看图选单词',
	'1202': '听声选单词',
	'1203': '看图听声选单词',
	'1204': '看句子选单词',
	'1205': '听声看句子选单词',
	'1206': '看图看句子选单词',
	'1207': '看句子选单词(带音频)',
	'1301': '看文选图音',
	'1401': '看图选句子',
	'1402': '听声选句子',
	'1403': '看图听声选句子',
	'1404': '看句子选句子',
	'1405': '听声看句子选句子',
	'1406': '看图看句子选句子',
	'1501': '听音选文本图片音频',
	'2101': '看图判断',
	'2102': '听声音判断',
	'2103': '看单词判断',
	'2104': '看图片听声音判断',
	'2105': '看图片和单词听声音判断',
	'3101': '看图拼单词',
	'4101': '图片单词连线',
	'5101': '看内容选答案',
	'8101': '听发音',
	'8102': '看图听音跟读',
	'8103': '翻转听音跟读',
	'8104': '看图听多音',
	'8201': '看图听音跟读',
	'8202': '听例句',
	'8203': '听例句(无图)',
	'8204': '看图听音',
	'8205': '单词卡牌',
	'8301': '听音跟读',
	'8401': '对话跟读',
	'8402': '对话跟读(无图)',
	'8501': '看图听音跟读',
	'8502': '看图听音',
	'8503': '看图说话',
	'8504': '听音跟读',
	'8505': '朗读',
	'8601': '看图回答问题(选单词)',
	'8602': '看图回答问题(选句子)',
	'8604': '看句子，找错误',
	'8506': '听音不录音',
	'3102': '看图组装句子',
	'9101': '看图听音拼写单词',
	'1208': '听音选划线单词',
	'1502': '听音选音',
	'3103': '看图听音拼写句子'
};

const TEXTBOOK_VERSIONS = [
	{ version: 0, name: '第1版' },
	{ version: 1, name: '第2版' },
	{ version: 2, name: '第3版' },
	{ version: 3, name: '第4版' },
	{ version: 4, name: '第5版' },
	// { version: 5, name: '第6版' }
];

// 试卷标准，默认标准题型
const PAPER_STANDARD = [
	{ type: '2', label: '智能推题' },
	{ type: '', label: '普通' },
];

export {
	BOARDS,
	TRAININGS,
	QUESTION_TYPES,
	TEXTBOOK_VERSIONS,
	PAPER_STANDARD
};